import { Icons } from '../assets'
import { NavigationItem } from '../types/model'
import texts from './texts'

// PAYPER-1181: reintentos de resumen/contexto mientras el back responde 202.
export const GENERATION_RETRY_INTERVAL_MS = 1000
export const GENERATION_MAX_RETRIES = 10

export const DEFAULT_BAR_ACTIONS = [
  {
    name: NavigationItem.Home,
    icon: Icons.Home,
    label: texts.navHome,
    disabled: false,
  },
  {
    name: NavigationItem.Search,
    icon: Icons.Search,
    label: texts.navSearch,
    disabled: true,
  },
  {
    name: NavigationItem.Favorite,
    icon: Icons.Star,
    label: texts.navFavorite,
    disabled: true,
  },
  {
    name: NavigationItem.Summary,
    icon: Icons.Summary,
    label: texts.navSummary,
    disabled: true,
  },
  {
    name: NavigationItem.Coverage,
    icon: Icons.Coverage,
    label: texts.navCoverage,
    disabled: true,
  },
  {
    name: NavigationItem.Context,
    icon: Icons.Context,
    label: texts.navContext,
    disabled: true,
  },
]
